import { useMutation, useQuery } from "@apollo/client";
import {
  BEGIN_PLATFORM_FUNDING_SOURCE,
  COMPLETE_PLATFORM_FUNDING_SOURCE,
  FUND_PLATFORM_REWARDS,
  GET_PLATFORM_FUNDING_SOURCES,
  GET_PLATFORM_REWARDS_POOLS,
  REMOVE_PLATFORM_FUNDING_SOURCE,
} from "graphql/platform";
import type {
  PlatformFundingSource,
  PlatformRewardsPool,
} from "components/platform/rewards/types";

export function usePlatformRewards() {
  const pools = useQuery<{ platformRewardsPools: PlatformRewardsPool[] }>(
    GET_PLATFORM_REWARDS_POOLS,
    { fetchPolicy: "network-only" },
  );
  const sources = useQuery<{ platformFundingSources: PlatformFundingSource[] }>(
    GET_PLATFORM_FUNDING_SOURCES,
    { fetchPolicy: "network-only" },
  );
  const [beginFundingSource, beginState] = useMutation(
    BEGIN_PLATFORM_FUNDING_SOURCE,
    { onCompleted: () => sources.refetch() },
  );
  const [removeFundingSource, removeState] = useMutation(
    REMOVE_PLATFORM_FUNDING_SOURCE,
    { onCompleted: () => sources.refetch() },
  );
  const [completeFundingSource, completeState] = useMutation(
    COMPLETE_PLATFORM_FUNDING_SOURCE,
    { onCompleted: () => sources.refetch() },
  );
  const [fundRewards, fundState] = useMutation(FUND_PLATFORM_REWARDS, {
    onCompleted: () => pools.refetch(),
  });

  return {
    pools: pools.data?.platformRewardsPools ?? [],
    poolsLoading: pools.loading,
    poolsError: pools.error,
    refetchPools: pools.refetch,
    fundingSources: sources.data?.platformFundingSources ?? [],
    sourcesLoading: sources.loading,
    sourcesError: sources.error,
    beginFundingSource,
    completeFundingSource,
    removeFundingSource,
    fundRewards,
    saving:
      beginState.loading ||
      removeState.loading ||
      completeState.loading ||
      fundState.loading,
  };
}

export default usePlatformRewards;
